import React, { ReactElement } from 'react';

import { Sheet } from '../../../../../../mobile/structural/sheet/Sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { Label } from '../../../../../../../common/labels/labelTypes';
import LabelColorPicker from '../components/LabelColorPicker';
import { Input } from '@milanote/roma';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import useLabelNameEditor from './useLabeSheetlNameEditor';
import CustomColorInput from '../../colorTools/CustomColorInput';
import { useLabelColorSheetHandler } from '../hooks/useLabelColorSheetHandler';

type LabelEditSheetProps = {
    label: Label;
    sheetProps: UseSheetReturnType;
};

const LabelEditSheet = (props: LabelEditSheetProps): ReactElement => {
    const { label, sheetProps } = props;

    const translate = useTranslator('popup', 'labels.edit');
    const { labelName, setLabelName, handleBlur, handleKeyDown } = useLabelNameEditor(label);
    const {
        selectedColor,
        selectedColorHex,
        showCustomColorInput,
        customColorInputRef,
        handleTempColorChange,
        handleColorChange,
        openCustomColorPicker,
        onCustomColorInputFocus,
        onCustomColorInputBlur,
    } = useLabelColorSheetHandler(label, sheetProps);

    return (
        <>
            <Sheet className="LabelEditSheet color-tool" {...sheetProps}>
                <Sheet.Overlay />
                <Sheet.Panel>
                    <Sheet.Header>
                        <Sheet.Heading>{translate('heading')}</Sheet.Heading>
                        <Sheet.DoneButton />
                    </Sheet.Header>
                    <Sheet.Content className="px-3xl pt-lg">
                        <div className="pb-3xl flex flex-col gap-3xl">
                            <Input
                                size="lg"
                                value={labelName}
                                onChange={setLabelName}
                                onBlur={handleBlur}
                                onKeyDown={handleKeyDown}
                            />
                            <LabelColorPicker
                                selectedColor={selectedColor ? selectedColor : null}
                                selectedColorHex={selectedColorHex}
                                openCustomColorPicker={openCustomColorPicker}
                                handleColorChange={handleColorChange}
                            />
                        </div>
                    </Sheet.Content>
                </Sheet.Panel>
            </Sheet>

            {showCustomColorInput && (
                <CustomColorInput
                    className="custom-color-picker-input absolute opacity-0 pointer-events-none"
                    ref={customColorInputRef}
                    initialColor={selectedColorHex}
                    setTempColor={handleTempColorChange}
                    setColor={handleColorChange}
                    onFocus={onCustomColorInputFocus}
                    onBlur={onCustomColorInputBlur}
                />
            )}
        </>
    );
};

export default LabelEditSheet;
